import { UserData } from './_props'

const emptyData: UserData = {
    objectId: '',
    rpps: '',
    idnps: '',
    role: '',
    civility: '',
    prefix: '',
    lastName: '',
    firstName: '',
    qualification: '',
    profession: '',
    speciality: '',
    mentionsAndTitles: [],
    contactPhone: '',
    privatePhone: '',
    email: '',
    securedEmail: '',
    sex: '',
}

const mandatoryFields = ['civility', 'lastName', 'firstName', 'qualification', 'profession', 'email']

const civilities = [
    {
        value: 'M',
        label: 'Monsieur',
    },
    {
        value: 'MME',
        label: 'Madame',
    },
]

const titles = [
    {
        value: 'Dr',
        label: 'Docteur',
    },
    {
        value: 'Pr',
        label: 'Professeur',
    },
]

const displayNames: Record<string, string> = {
    active: 'Actif',
    new: 'Nouveau',
    refused: 'Refusé',
    pending: 'En attente',
}

export { emptyData, mandatoryFields, civilities, titles, displayNames }
